var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cssDataRef",staticClass:"main-container"},[_c('img',{staticClass:"main-bg",attrs:{"src":_vm.homeBgImg,"alt":""}}),_c('MainAnnouncement'),_c('MainNotice'),_c('MainSystem')],1)}
var staticRenderFns = []

export { render, staticRenderFns }